//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fixSafariOverflowScrolling from '../../utils/safari-fix'
import { Card, CardItem, RouteCard } from '../Common/Card'
import MatchEmpty from '../Common/MatchEmpty.vue'
import FilterOption from '../Common/FilterOption.vue'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'route-list',
  components: {
    Card,
    CardItem,
    RouteCard,
    MatchEmpty,
    FilterOption,
  },
  mounted() {
    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling')
    fixSafariOverflowScrolling(this, 'touch')
  },
  data: () => ({
    placeholder: '加载中...',
    selectedOption: {},
    selectedType: '',
    optionType: '',
    showFilter: false,
    options: [],
    selected: {
      category: {},
      city: {},
      date: {},
    },
    filter: {
      category: '',
      city: '',
      date: '',
    },
    /* width: 100% - image width - page-padding - card-padding */
    width: (window.innerWidth || document.body.clientWidth) - 120 - 20 - 8,
  }),
  computed: {
    ...mapState({
      categories: ({ routes }) => routes.categories,
      cities: ({ routes }) => routes.cities,
      dateLabels: ({ routes }) => routes.dateLabels,
      routes: ({ routes }) => routes.routes,
    }),
  },
  methods: {
    ...mapActions(['fetchRouteCategory', 'fetchRouteList', 'fetchRouteFilter']),
    isEmpty(routes) {
      if (routes.routes.length === 0) {
        this.placeholder = '没有线路数据'
      }
    },
    onFilterClose() {
      if (this.showFilter) {
        this.showFilter = false
      }
    },
    toggleFilterOption(opts, type) {
      this.options = opts
      this.showFilter = true
      this.selectedType = type
      if (this.selectedType === 'category') {
        this.selectedOption = this.selected.category
        this.optionType = 'multi'
      } else if (this.selectedType === 'city') {
        this.selectedOption = this.selected.city
        this.optionType = 'multi'
      } else if (this.selectedType === 'date') {
        this.optionType = 'single'
        this.selectedOption = this.selected.date
      }
    },
    handleOptionChanged(option, show) {
      this.showFilter = show
      if (this.selectedType === 'category') {
        this.selected.category = option
        // clear selected city && date
        this.selected.city = {}
        this.selected.date = {}
        this.filter.category = option.id
        this.handleCategoryChanged()
      } else if (this.selectedType === 'city') {
        this.selected.city = option
        this.filter.city = option.id
        this.handleCityChanged()
      } else if (this.selectedType === 'date') {
        this.selected.date = option
        if (option.start) {
          this.filter.date = `${option.start}|${option.end}`
        } else {
          this.filter.date = ''
        }
        this.handleDateChanged()
      }
    },
    handleCategoryChanged() {
      this.filter.city = ''
      this.filter.date = ''
      this.fetchRouteList({
        categoryId: this.filter.category,
      }).then(this.isEmpty)

      this.fetchRouteFilter(this.filter.category)
    },
    handleCityChanged() {
      this.filter.date = ''
      this.fetchRouteList({
        categoryId: this.filter.category,
        cityId: this.filter.city,
      }).then(this.isEmpty)
    },
    handleDateChanged() {
      this.fetchRouteList({
        categoryId: this.filter.category,
        cityId: this.filter.city,
        time: this.filter.date,
      }).then(this.isEmpty)
    },
  },
  created() {
    this.fetchRouteCategory()
    this.fetchRouteFilter()
    this.fetchRouteList().then(this.isEmpty)
  },
}



// WEBPACK FOOTER //
// ./client/components/Route/RouteList.vue